import cx from 'classnames';

import { ImageOverlayChip } from 'src/components/ImageOverlayChip';
import { TagsPositioner } from 'src/components/TagsPositioner';
import { getImageOverlayPropsValues } from 'src/data/image';

import { useStyles } from './useStyles';

export const ImageOverlayTextValue = ({ className, imageOverlayProperties }) => {
  const styles = useStyles();

  const items = getImageOverlayPropsValues(imageOverlayProperties);
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      <TagsPositioner
        className={styles.tagsPositioner}
        classes={{ labelMore: styles.labelMore }}
        items={items || []}
        maxRows={1}
        moreLabelMaxWidth={28}
        horizontalTagsGap={6}
      >
        {({ item, ...restProps }) => (
          <ImageOverlayChip
            className={styles.chip}
            text={item}
            {...restProps}
          />
        )}
      </TagsPositioner>
    </div>
  );
};
